export default [
  {
    path: '/favorites',
    name: 'favorites',
    component: () => import('./views/FavoritesPage.vue'),
    meta: {
      requiresAuth: true,
      headerColor: '#FFFFFF'
    }
  }
];
